// the "Book again" destination is region-specific since USA and AUS have their own booking sites
export const getBookingUrl = (): string => {
  switch (process.env.REACT_APP_REGION) {
    case "aus":
      return "https://flightclubdarts.com.au";
    case "usa":
      return "https://www.flightclubdartsusa.com";
    case "ie":
      return "https://flightclubdarts.com/ie";
    default:
      return "https://flightclubdarts.com";
  }
};
